export default "__VITE_ASSET__c721947f__"